module.exports = __webpack_public_path__ + "img/sigh.20d39eea.svg";